import { render, staticRenderFns } from "./service-local.vue?vue&type=template&id=069627f1&scoped=true"
import script from "./service-local.vue?vue&type=script&lang=js"
export * from "./service-local.vue?vue&type=script&lang=js"
import style0 from "./service-local.vue?vue&type=style&index=0&id=069627f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069627f1",
  null
  
)

export default component.exports